import React from 'react';
import './Home.css';

const CampaignFinished = () => {
  return (
    <div className="finish-page-container">
      <div className="page-header">
        <h2 className="page-subtitle">投票活動已結束，誠意感謝大家一直以來的支持。</h2>
        <p className="page-subtitle">
          得獎結果將於 2027年1 月 15 日頒獎典禮正式公布，並會於翌日上載至 <a className="link" href="https://mca.hkaim.org/#home" target="_blank">AIM網站</a> 及 <a className="link" href="https://www.facebook.com/HKAIM.ORG" target="_blank">社交平台</a>，敬請密切留意。
        </p>
      </div>
    </div>
  );
};

export default CampaignFinished;
